<template>
  <div class="giftCardCg">
    <Row>
      <div>
        <Breadcrumb separator=">" :style="{ margin: '24px 0' }">
          <BreadcrumbItem>我的账户</BreadcrumbItem>
          <BreadcrumbItem>旅游卡中心</BreadcrumbItem>
          <BreadcrumbItem>旅游卡发放</BreadcrumbItem>
        </Breadcrumb>
        <div slot="title" class="cardTitle2">
          <p>分销商信息</p>
        </div>
        <div class="distributor">
          分销商:<span class="name">{{ corpname }}</span>
        </div>
        <div class="select">
          <div slot="title" class="cardTitle2">
            <p>选择旅游卡</p>
          </div>
          <div class="select-item">
            <Form
              ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate"
              :label-width="80"
              inline
              label-position="left"
            >
              <FormItem label="旅游卡:" prop="card">
                <Select
                  v-model="formValidate.card"
                  style="width: 386px"
                  :label-in-value="true"
                  @on-change="changeCard"
                >
                  <Option
                    v-for="item in cardList"
                    :value="item.value"
                    :key="item.value"
                    >{{ item.label }}</Option
                  >
                </Select>
              </FormItem>
            </Form>

            <div class="num-item">
              <ul class="num">
                <li>
                  总库存: <span>{{ cardNum }}</span>
                </li>
                <li>
                  未发放库存: <span>{{ nogrant }}</span>
                </li>

                <li>
                  已发放(待实名): <span>{{ notrealname }}</span>
                </li>
                <li>
                  已发放(已实名): <span>{{ isrealname }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="fasong">
          <div slot="title" class="cardTitle2">
            <p>旅游卡发送</p>
          </div>
          <div class="item">
            <div
              class="item-left"
              @click="flag = 2"
              :class="{ active: flag === 2 }"
            >
              单张发送
            </div>
            <div
              class="item-right"
              @click="flag = 1"
              :class="{ active: flag === 1 }"
            >
              批量发送
            </div>
          </div>
        </div>
        <!-- 批量发送 -->
        <div class="box" v-if="flag === 1">
          <div class="box-item">
            <div class="item1">批量导入:</div>
            <Input
              class="input-default"
              v-model="excelFileName"
              style="width: 300px"
              readonly
            >
            </Input>
            <div class="item2">
              <!-- 批量上传 -->
              <span @click="up($event)">选择本地文件</span>
              <input
                v-if="clearShow"
                style="display: none"
                id="uploadEventFile"
                accept="application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                ref="file"
                name="fileinfo"
                type="file"
                @change="inputCustomProduct($event)"
              />
            </div>
            <div class="item3" @click="exportData">下载名单模板</div>
          </div>
          <Button class="btn" type="primary" @click="getExcelFile">
            导入预览区
          </Button>
          <!-- 批量发送内容 -->
          <div class="content1">
            <div class="title">
              <div class="left">
                <div
                  class="err"
                  @click="tabel = 2"
                  :class="{ active: tabel === 2 }"
                >
                  异常名单&nbsp;(<span>{{ abnormal }}</span
                  >)
                </div>
                <div
                  class="all"
                  @click="tabel = 1"
                  :class="{ active: tabel === 1 }"
                >
                  正常名单&nbsp;(<span>{{ normal }}</span
                  >)
                </div>
              </div>
              <div class="right">
                <ul class="num">
                  <li>
                    当前库存剩余: <span>{{ nogrant }}</span>
                  </li>
                  <li>
                    名单总人数:
                    <span>{{ amount }}</span>
                  </li>
                  <li>
                    异常:
                    <span>{{ abnormal }}</span>
                  </li>
                  <li>
                    发放后消耗库存:
                    <span>{{ normal }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 异常数据表格 -->
            <div class="tabels1" v-if="tabel === 2">
              <Table :columns="colname" :data="historyData1"></Table>
              <Page
                v-show="historyData1.length > 0"
                class="paging"
                :total="dataCount1"
                :page-size="pageSize"
                @on-change="changepage1"
                prev-text="上一页"
                next-text="下一页"
              ></Page>
            </div>
            <!-- 全部数据表格 -->
            <div class="tabels1" v-if="tabel === 1">
              <Table :columns="colname" :data="historyData"></Table>
              <Page
                v-if="historyData.length > 0"
                class="paging"
                :total="dataCount"
                :page-size="pageSize"
                @on-change="changepage"
                prev-text="上一页"
                next-text="下一页"
              ></Page>
            </div>
          </div>
        </div>

        <!-- 单张发送内容 -->
        <div class="content2" v-if="flag === 2">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            inline
            :label-width="80"
            label-position="left"
          >
            <Row>
              <Col span="8">
                <FormItem prop="mobileNum" label="手机号:">
                  <Input
                    type="text"
                    v-model="formInline.mobileNum"
                    placeholder="请输入手机号(必填)"
                    style="width: 200px; height: 32px"
                  >
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="userName" label="姓名:">
                  <Input
                    type="text"
                    v-model="formInline.userName"
                    placeholder="请输入姓名(选填)"
                    style="width: 200px; height: 32px"
                  >
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="idcard" label="身份证号:">
                  <Input
                    type="text"
                    v-model="formInline.idcard"
                    placeholder="请输入身份证(选填)"
                    style="width: 200px; height: 32px"
                  >
                  </Input>
                </FormItem>
              </Col>
            </Row>
          </Form>
          <Button type="primary" @click="doSola">导入预览区</Button>
          <!-- 表格 -->
          <div class="tabels">
            <div class="title">
              <div class="left">名单预览</div>
              <div class="right">
                <ul class="num">
                  <li>
                    当前库存剩余: <span>{{ nogrant }}</span
                    >人
                  </li>
                  <li>
                    名单总人数: <span>{{ tabelData.length }}</span>
                  </li>
                  <li>
                    异常: <span>{{ oneNum }}</span>
                  </li>
                  <li>
                    发放后消耗库存: <span>{{ tabelData.length - oneNum }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 单张数据表格 -->
            <div class="tabels1">
              <Table border :columns="colnamess" :data="tabelData"></Table>
            </div>
          </div>
        </div>

        <!-- 短信模板 -->
        <div class="item">
          <div class="title">短信内容模板：</div>
          <Input
            v-if="flag === 2"
            type="textarea"
            class="input"
            :rows="4"
            v-model="note"
            placeholder=""
          ></Input>
          <Input
            v-if="flag === 1"
            type="textarea"
            class="input"
            :rows="4"
            v-model="duanxin"
            placeholder=""
          ></Input>
        </div>
        <div class="btn">
          <div v-if="flag === 1">
            <Button type="primary" @click="batch">批量发送</Button>
          </div>
          <div v-else>
            <Button type="primary" @click="submit">确认发送</Button>
            <span>（*再次点击进行重新发送，不消耗库存）</span>
          </div>
        </div>
      </div>
      <loading v-if="spinShow"></loading>
    </Row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clearShow: true, // 上传文件时,相同文件重复上传
      // modal10: false,
      corpname: "", // 分销商名字
      cardNum: 0, // 总卡数
      nogrant: 0, // 未发放库存
      isrealname: 0, // 已实名
      notrealname: 0, //未实名
      oneNum: 0, // 单张异常人数
      abnormal: 0, // 异常名单总人数
      amount: 0,
      normal: 0, //正常名单总人数
      spinShow: true,
      cardList: [], // 下拉框内容
      model1: "",
      note: "", // 短信内容
      flag: 1, // 判断单张还是批量
      tabel: 1, // 判断正常或异常
      excelFileName: "", // 上传文件
      tabelData: [], // 单张数据
      historyData: [], // 批量全部数据
      historyData1: [], // 批量异常数据
      total: 0,
      loading: false,
      // 单张发送表格数据
      formInline: {
        mobileNum: "",
        userName: "",
        idcard: "",
        format: "",
      },
      batchid: "",
      cardId: "",
      // 验证手机号
      ruleInline: {
        mobileNum: [
          {
            required: true,
            trigger: "blur",
            validator: this.$reg.mobile,
          },
        ],
      },
      tableData: [],
      // 初始化信息总条数
      dataCount: 0,
      dataCount1: 0,
      // 每页显示多少条
      pageSize: 10,
      colname: [
        {
          title: "发送序号",
          width: 100,
          align: "center",
          render: (h, params) => {
            return h("span", params.index + 1);
          },
        },
        {
          title: "手机号",
          align: "center",
          key: "mobileNum",
        },
        {
          title: "姓名",
          align: "center",
          key: "userName",
        },
        {
          title: "身份证号码",
          align: "center",
          key: "idcard",
          minWidth: 100,
        },
        {
          title: "格式检查",
          align: "center",
          key: "format",
          render: (h, params) => {
            if (params.row.status === "1") {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#41b883",
                    },
                  },
                  "通过"
                ),
              ]);
            } else {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#d14b48",
                    },
                  },
                  params.row.status
                ),
              ]);
            }
          },
        },
        {
          title: "状态",
          align: "center",
          key: "state",
          render: (h, params) => {
            return h("span", [
              h(
                "span",
                {
                  class: "hover_span",
                  style: {
                    marginRight: "10px",
                    color: "#41b883",
                  },
                },
                "未发送"
              ),
            ]);
          },
        },
      ],
      colnamess: [
        {
          title: "发送序号",
          width: 100,
          align: "center",
          render: (h, params) => {
            return h("span", params.index + 1);
          },
        },
        {
          title: "手机号",
          align: "center",
          key: "mobileNum",
        },
        {
          title: "姓名",
          align: "center",
          key: "userName",
        },
        {
          title: "身份证号码",
          align: "center",
          key: "idcard",
          minWidth: 100,
        },
        {
          title: "格式检查",
          align: "center",
          key: "format",
          render: (h, params) => {
            const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
            if (
              params.row.mobileNum !== "" &&
              params.row.idcard === "" &&
              params.row.userName === ""
            ) {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#41b883",
                    },
                  },
                  "通过",
                  (params.row.status = 2)
                ),
              ]);
            } else if (
              params.row.mobileNum !== "" &&
              reg.test(params.row.idcard) &&
              params.row.userName !== ""
            ) {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#41b883",
                    },
                  },
                  "通过",
                  (params.row.status = 2)
                ),
              ]);
            } else if (
              params.row.mobileNum !== "" &&
              !reg.test(params.row.idcard)
            ) {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#d14b48",
                    },
                  },
                  "不通过"
                ),
              ]);
            } else if (
              params.row.mobileNum !== "" &&
              reg.test(params.row.idcard) &&
              params.row.userName === ""
            ) {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#d14b48",
                    },
                  },
                  "不通过"
                ),
              ]);
            } else if (
              params.row.mobileNum !== "" &&
              params.row.idcard === "" &&
              params.row.userName !== ""
            ) {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#d14b48",
                    },
                  },
                  "不通过"
                ),
              ]);
            } else {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#d14b48",
                    },
                  },
                  "不通过"
                ),
              ]);
            }
          },
        },
        {
          title: "状态",
          align: "center",
          key: "status",
          render: (h, params, index) => {
            const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
            if (
              params.row.mobileNum !== "" &&
              params.row.idcard === "" &&
              params.row.userName === ""
            ) {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#41b883",
                    },
                  },
                  "未发送"
                ),
              ]);
            } else if (
              params.row.mobileNum !== "" &&
              !reg.test(params.row.idcard) &&
              params.row.userName === ""
            ) {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#d14b48",
                    },
                  },
                  "身份证号码错误,姓名未填写"
                ),
              ]);
            } else if (
              params.row.mobileNum !== "" &&
              reg.test(params.row.idcard) &&
              params.row.userName === ""
            ) {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#d14b48",
                    },
                  },
                  "姓名未填写"
                ),
              ]);
            } else if (
              params.row.mobileNum !== "" &&
              reg.test(params.row.idcard) &&
              params.row.userName === ""
            ) {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#d14b48",
                    },
                  },
                  "请填写姓名"
                ),
              ]);
            } else if (
              params.row.mobileNum !== "" &&
              params.row.idcard === "" &&
              params.row.userName !== ""
            ) {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#d14b48",
                    },
                  },
                  "请填写身份证号码"
                ),
              ]);
            } else if (
              reg.test(params.row.idcard) &&
              params.row.mobileNum !== "" &&
              params.row.idcard !== "" &&
              params.row.userName !== ""
            ) {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#41b883",
                    },
                  },
                  "未发送"
                ),
              ]);
            } else {
              return h("span", [
                h(
                  "span",
                  {
                    class: "hover_span",
                    style: {
                      marginRight: "10px",
                      color: "#d14b48",
                    },
                  },
                  "身份证号码错误"
                ),
              ]);
            }
          },
        },
      ],
      testData: {
        histories: [],
      }, // 全部分页
      ajaxHistoryData: [],
      testData1: {
        histories: [],
      }, // 异常分页
      ajaxHistoryData1: [],
      duanxin: "",

      anomalyTab: [],
      fileName: "",
      formValidate: {
        card: "",
      },
      ruleValidate: {
        card: [{ required: true, message: "请选择旅游卡!", trigger: "change" }],
      },
    };
  },
  methods: {
    // 批量上传
    // 上传文件
    up(event) {
      event.preventDefault();
      //因为样式问题，点击button按钮触发input
      $("#uploadEventFile").trigger("click");
    },
    inputCustomProduct(el) {
      this.clearShow = false;
      //声明一个FormDate对象
      let formData = new FormData();
      let file = el.target.files[0];
      //把文件信息放入对象中
      formData.append("access_token", sessionStorage.getItem("name"));
      formData.append("file", file);
      formData.append("cardId", this.cardId);
      this.$http
        .post(
          this.baseURL + "/tourcard/tourcard/v1/uploadTourcardExcelByUser",
          formData
        )
        .then((res) => {
          //上传成功
          this.clearShow = true;
          if (res.data.code === 200) {
            this.historyData = [];
            this.historyData1 = [];
            this.testData1.histories = [];
            this.testData.histories = [];
            this.normal = 0;
            this.abnormal = 0;
            this.amount = 0;
            // 后台返回表格名字
            this.fileName = res.data.data.fileName;
            this.excelFileName = file.name;
            // 区分名单
            res.data.data.infos.forEach((item) => {
              if (item.status !== "1") {
                // 异常
                this.testData1.histories.push(item);
              } else {
                // 正常
                this.testData.histories.push(item);
              }
            });
            // 名单总数
            this.amount = res.data.data.infos.length;
            this.$Message.success("上传成功!");
          }
        })
        .catch((result) => {
          //失败后调用的代码
          console.log("上传失败", result);
          this.$Message.error("服务器错误,请稍后重试");
        });
    },

    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "文件 " + file.name + " 格式不正确，请上传.xls,.xlsx文件。",
      });
    },
    // 全部名单分页
    handleListApproveHistory() {
      // 保存取到的所有数据
      this.ajaxHistoryData = this.testData.histories;
      this.dataCount = this.testData.histories.length;
      // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
      if (this.testData.histories.length < this.pageSize) {
        this.historyData = this.ajaxHistoryData;
      } else {
        this.historyData = this.ajaxHistoryData.slice(0, this.pageSize);
      }
      this.normal = this.historyData.length;
    },
    // 分页
    changepage(index) {
      var _start = (index - 1) * this.pageSize;
      var _end = index * this.pageSize;
      this.historyData = this.ajaxHistoryData.slice(_start, _end);
    },
    // 异常名单分页
    handleListApproveHistory1() {
      // 保存取到的所有数据
      this.ajaxHistoryData1 = this.testData1.histories;
      this.dataCount1 = this.testData1.histories.length;
      // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
      if (this.testData1.histories.length < this.pageSize) {
        this.historyData1 = this.ajaxHistoryData1;
      } else {
        this.historyData1 = this.ajaxHistoryData1.slice(0, this.pageSize);
      }
      this.abnormal = this.testData1.histories.length;
    },
    changepage1(index) {
      var _start = (index - 1) * this.pageSize;
      var _end = index * this.pageSize;
      this.historyData1 = this.ajaxHistoryData1.slice(_start, _end);
    },
    // 导出模板
    exportData() {
      this.$http({
        method: "post",
        responseType: "arraybuffer",
        url:
          this.baseURL +
          "/tourcard/tourcard/v1/downloadEcardBatchTemplate?access_token=" +
          sessionStorage.getItem("name"),
      }).then(
        (res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "名单模板"; // 自定义文件名
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        (err) => {
          var enc = new TextDecoder("utf-8");
          var res = JSON.parse(enc.decode(new Uint8Array(err.data))); //转化成json对象
        }
      );
    },
    // 批量导入预览区
    getExcelFile() {
      this.$refs.formValidate.validate((valid) => {
        if (!valid) {
          this.$Message.error("请选择旅游卡!");
        } else if (this.nogrant <= 0) {
          this.$Message.error("旅游卡库存不足!");
        } else if (!this.excelFileName) {
          this.$Message.error("请导入名单文件！");
        } else if (this.amount > this.nogrant) {
          this.$Message.error("旅游卡库存不足!");
        } else {
          this.handleListApproveHistory1();
          this.handleListApproveHistory();
          this.$http
            .post(
              this.baseURL +
                "/tourcard/tourCardOrder/v1/getBatchSmsTemplate?access_token=" +
                sessionStorage.getItem("name")
            )
            .then((res) => {
              //成功后调返回短信模板
              this.duanxin = res.data.data;
            })
            .catch((result) => {
              //失败后调用的代码
              console.log(result);
            });
        }
      });
    },
    // 单张导入预览区
    doSola() {
      const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      const mobile = /^(13[0-9]|14[5-9]|15[0-9]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      this.$refs.formValidate.validate((valid) => {
        if (!valid) {
          this.$Message.error("请选择旅游卡!");
          return;
        } else if (valid && !this.nogrant) {
          this.$Message.error("库存不足,无法发送!");
          return;
        } else if (this.nogrant <= 0) {
          this.$Message.error("库存不足!");
          return;
        }

        if (
          this.formInline.mobileNum !== "" &&
          mobile.test(this.formInline.mobileNum)
        ) {
          this.tabelData = [];
          const arr = JSON.parse(JSON.stringify(this.formInline));
          this.tabelData.push(arr);
          this.$http
            .post(
              this.baseURL +
                "/tourcard/tourCardOrder/v1/getBatchSmsTemplate?access_token=" +
                sessionStorage.getItem("name")
            )
            .then((res) => {
              //成功后调用的代码
              this.note = res.data.data;
            })
            .catch((result) => {
              //失败后调用的代码
              console.log(result);
            });
        } else if (this.formInline.mobileNum === "") {
          this.$Message.error("请输入手机号!");
        } else if (!mobile.test(this.formInline.mobileNum)) {
          this.$Message.error("手机号格式错误!");
        }
      });

      if (reg.test(this.formInline.idcard) || this.formInline.idcard === "") {
        this.oneNum = 0;
      } else {
        this.oneNum = 1;
      }
    },
    // 选择卡
    changeCard(data) {
      this.formInline.mobileNum = "";
      this.formInline.userName = "";
      this.formInline.idcard = "";
      this.tabelData = [];
      this.note = "";
      const arr = data.value.split("_");
      this.cardId = arr[1];
      this.batchid = arr[0];

      this.getDataList();

      this.$nextTick(() => {
        const _arr = JSON.parse(sessionStorage.getItem("card"));
        _arr.forEach((item) => {
          if (arr[0] === item.batchid) {
            this.isrealname = item.isrealname;
            this.notrealname = item.notrealname;
            this.nogrant = item.total - (this.isrealname + this.notrealname);
            this.cardNum = item.total;
          }
        });
      });
    },
    // 确定发送
    async submit() {
      const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!this.tabelData.length) {
        this.$Message.error("请先导入名单信息!");
      } else if (
        reg.test(this.formInline.idcard) &&
        this.tabelData[0].userName === ""
      ) {
        this.$Message.error("姓名未填写,请填写姓名");
      } else if (this.tabelData[0].mobileNum !== this.formInline.mobileNum) {
        this.$Message.error("手机号已修改,请重新导入到预览区!");
      } else if (this.tabelData[0].userName !== this.formInline.userName) {
        this.$Message.error("姓名已修改,请重新导入到预览区!");
      } else if (this.tabelData[0].idcard !== this.formInline.idcard) {
        this.$Message.error("身份证已修改,请重新导入到预览区!");
      } else if (
        reg.test(this.formInline.idcard) ||
        this.formInline.idcard === ""
      ) {
        const obj = {
          access_token: sessionStorage.getItem("name"),
          batchid: this.batchid,
          userId: sessionStorage.getItem("usid"),
          cardNum: this.cardId,
          identityNum: this.formInline.idcard.trim(),
          mobileNum: this.formInline.mobileNum.trim(),
          userName: this.formInline.userName.trim(),
        };
        const res = await this.$http.post(
          this.baseURL +
            "/tourcard/tourCardOrder/v1/openEcard?access_token=" +
            sessionStorage.getItem("name") +
            "&url=" +
            window.location.host,
          obj
        );
        if (res.data.code === 200) {
          this.$Spin.show();
          setTimeout(() => {
            this.formInline.mobileNum = "";
            this.formInline.userName = "";
            this.formInline.idcard = "";
            this.note = "";
            this.tabelData = [];
            this.nogrant--;
            this.notrealname++;
            this.$Spin.hide();
            this.$Message.success("短信发送成功!");
            this.oneNum = 0;
            this.getDataList();
          }, 500);
        } else if (res.data.code === 400) {
          this.$Message.error(res.data.msg);
        } else {
          this.$Message.error("服务器错误，请联系运营人员");
        }
      }
    },
    // 批量发送
    batch() {
      this.$refs.formValidate.validate((vaild) => {
        if (!vaild) {
          this.$Message.error("请选择旅游卡!");
        } else if (this.nogrant === 0 || this.nogrant < this.amount) {
          this.$Message.error("库存不足,无法发送!");
        } else if (this.excelFileName === "") {
          this.$Message.error("请导入名单文件!");
        } else if (!this.historyData1.length && !this.historyData.length) {
          this.$Message.error("请将数据导入预览区");
        } else if (this.historyData1.length > 0) {
          this.$Message.error("存在异常名单,请检查修改后再发送");
        } else {
          const obj = {
            access_token: sessionStorage.getItem("name"),
            batchid: this.batchid,
            fileurl: this.fileName,
            usid: sessionStorage.getItem("usid"),
          };

          this.$http
            .post(
              this.baseURL +
                "/tourcard/tourcard/v1/doBatchUploadByUser?access_token=" +
                sessionStorage.getItem("name"),
              obj
            )
            .then((res) => {
              if (res.data.code === 200) {
                //成功后调用的代码
                this.$Spin.show();
                setTimeout(() => {
                  this.testData.histories = [];
                  this.testData1.histories = [];
                  this.historyData = [];
                  this.historyData1 = [];
                  this.nogrant = this.nogrant - this.normal;
                  this.notrealname = this.notrealname + this.normal;
                  this.excelFileName = "";
                  this.note = "";
                  this.normal = 0;
                  this.abnormal = 0;
                  this.amount = 0;
                  this.$Spin.hide();
                  this.$Message.success("短信批量发送成功!");
                }, 1500);
              } else if (res.data.code === 400) {
                this.$Message.error(res.data.msg);
              } else {
                this.$Message.error("服务器错误，请联系运营人员");
              }
            })
            .catch((result) => {
              //失败后调用的代码
              console.log("批量发送失败", result);
            });
        }
      });
    },
    // 获取旅游卡
    async getDataList() {
      const res = await this.$api.get(
        this.baseURL +
          `/tourcard/tourCardOrder/v1/getEcardByUsid/${sessionStorage.getItem(
            "userName"
          )}`
      );
      if (res.code === 200) {
        const _arr = [];
        res.data.forEach((item) => {
          if (item.total - item.isrealname - item.notrealname !== 0) {
            _arr.push({
              value: item.batchid + "_" + item.cardId,
              label: item.batchid + "_" + item.cardName,
            });
          }
        });
        this.cardList = _arr;
        sessionStorage.setItem("card", JSON.stringify(res.data));
      } else {
        this.$Message.error(res.msg);
      }
    },
  },
  async mounted() {
    this.corpname = sessionStorage.getItem("corpname");
    this.spinShow = false;

    // this.getDataList();
    const res = await this.$api.get(
      this.baseURL +
        `/tourcard/tourCardOrder/v1/getEcardByUsid/${sessionStorage.getItem(
          "userName"
        )}`
    );
    if (res.code === 200) {
      res.data.forEach((item) => {
        if (item.total - item.isrealname - item.notrealname !== 0) {
          this.cardList.push({
            value: item.batchid + "_" + item.cardId,
            label: item.batchid + "_" + item.cardName,
          });
        }
      });
      let _arr = res.data.filter((item) => {
        return item.total - item.isrealname - item.notrealname !== 0;
      });
      this.cardId = _arr[0].cardId;
      this.batchid = _arr[0].batchid;
      this.formValidate.card = this.cardList[0].value;
      this.isrealname = _arr[0].isrealname;
      this.notrealname = _arr[0].notrealname;
      this.nogrant = _arr[0].total - (this.isrealname + this.notrealname);
      this.cardNum = _arr[0].total;
      sessionStorage.setItem("card", JSON.stringify(res.data));
    } else {
      this.$Message.error(res.msg);
    }
  },
};
</script>

<style lang="less" scoped>
.giftCardCg {
  .distributor {
    font-size: 14px;
    color: #505a6e;
    padding-bottom: 24px;
    margin-bottom: 16px;
    border-bottom: 1px solid #e6e6e6;
    .name {
      font-size: 14px;
      color: #333;
      margin-left: 16px;
    }
  }
  .select {
    .item {
      font-size: 14px;
      color: #505a6e;
      margin-right: 16px;
    }
    .num-item {
      margin-top: -20px;
      border-bottom: 1px solid #e6e6e6;
      .num {
        font-family: PingFangSC-Medium;
        width: 600px;
        display: flex;
        font-size: 14px;
        color: #333333;
        margin-top: 16px;
        padding-bottom: 24px;
        li {
          flex: 2;
          &:nth-child(2) {
            flex: 3;
          }
          &:nth-child(3) {
            flex: 3;
          }
          &:nth-child(4) {
            flex: 3;
          }
        }
      }
    }
  }
  .fasong {
    height: 100px;
    padding-top: 16px;
    border-bottom: 1px solid #e6e6e6;
    .item {
      display: flex;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #979799;
      letter-spacing: 0;
      margin-top: 14px;
      .item-right {
        cursor: pointer;
        margin-left: 24px;
      }
      .item-left {
        cursor: pointer;
      }
      .active {
        color: #303133;
      }
    }
  }
  // 批量发送
  .box {
    .box-item {
      display: flex;
      align-items: center;
      text-align: center;
      padding-top: 24px;
      .item1 {
        margin-right: 16px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #505a6e;
      }
      .item2,
      .item3 {
        cursor: pointer;
        margin-left: 12px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #2f61ff;
      }
    }
    .btn {
      margin-top: 18px;
      margin-bottom: 36px;
    }
  }

  // 批量发送内容
  .content1 {
    width: 100%;
    .title {
      height: 40px;
      .left {
        height: 40px;
        float: left;
        display: flex;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #979799;
        letter-spacing: 0;
        line-height: 40px;
        .err {
          cursor: pointer;
          margin-right: 22px;
        }
        .all {
          cursor: pointer;
        }
        .active {
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #303133;
          letter-spacing: 0;
          border-bottom: 3px solid #4a83ff;
        }
      }
      .right {
        height: 40px;
        float: right;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #333333;
        text-align: right;
        line-height: 40px;
        .num {
          display: flex;
          align-items: center;
          li {
            margin-left: 20px;
          }
        }
      }
    }
    .tabels1 {
      margin-top: 10px;
      .paging {
        text-align: center;
        margin-top: 12px;
      }
    }
  }
  // 单张发送内容
  .content2 {
    padding-top: 26px;
    .tabels {
      padding-top: 36px;
      .tabels1 {
        margin-top: 10px;
        .paging {
          text-align: center;
          margin-top: 12px;
        }
      }
      .title {
        height: 40px;
        .left {
          height: 40px;
          float: left;
          display: flex;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #303133;
          letter-spacing: 0;
          line-height: 40px;
        }
        .right {
          height: 40px;
          float: right;
          font-family: PingFangSC-Medium;
          font-size: 12px;
          color: #333333;
          text-align: right;
          line-height: 40px;
          .num {
            display: flex;
            align-items: center;
            li {
              margin-left: 20px;
            }
          }
        }
      }
    }
  }
  .item {
    // height: 80px;
    padding-bottom: 36px;
    .title {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #303133;
      letter-spacing: 0;
      margin-top: 36px;
      margin-bottom: 14px;
    }
    .input {
      width: 540px;
      height: 80px;
    }
  }
  .btn {
    margin-bottom: 60px;
  }
}
</style>
